import { useCallback } from "react";
import axiosInstance from "../axiosInstance";

const usePostGuestList = () =>
  useCallback((data) => {
    const baseUrl = window.localStorage.getItem("BaseURL");
    const endpoint = "/services/projectmanagement/api/guest-groups";
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance
        .post(fullUrl, data)
        .then((res) => resolve(res.data))
        .catch(reject);
    });
  }, []);

export default usePostGuestList;
